export default __webpack_public_path__ + "static/media/icon_enterprise.aef20d61.svg";